import { DataTablePaginate } from '@/common/ui/table/data-table-paginate'
import { DataTableSelector } from '@/common/ui/table/data-table-selector'
import { GetCouponsDataResponse } from '../../type'
import { columns } from './constants'
import { DataTableSearch } from '@/common/ui/table/data-table-search'
import { DataTableResetFilter } from '@/common/ui/table/data-table-reset-filter'
import { Button } from '@/common/ui/button'
import { toast } from 'sonner'

interface CouponTableProps {
	data: GetCouponsDataResponse[]
	total: number
	isLoading?: boolean
}

export default function CouponTable({
	data,
	total,
	isLoading,
}: CouponTableProps) {
	const statusOptions = [
		{ label: 'ใช้แล้ว', value: 'USED' },
		{ label: 'ยังไม่ใช้', value: 'ACTIVE' },
		{ label: 'หมดอายุ', value: 'EXPIRED' },
	]

	const handleCopyAllCodes = () => {
		const codes = data.map((item) => item.code).join('\n')
		navigator.clipboard.writeText(codes).then(() => {
			toast.success('คัดลอกสำเร็จ')
		})
	}

	return (
		<div className="space-y-4">
			<div className="flex items-center justify-between">
				<div className="flex flex-wrap items-center gap-4">
					<DataTableSelector
						options={statusOptions}
						placeholder="เลือกสถานะ"
						label="สถานะ"
					/>
					<DataTableSearch placeHolder="ค้นหาด้วยรหัสคูปอง" />
					<DataTableResetFilter />
				</div>
				<Button
					variant="outline"
					onClick={handleCopyAllCodes}
					disabled={data.length === 0}
				>
					คัดลอกคูปองทั้งหมด
				</Button>
			</div>
			<DataTablePaginate
				columns={columns}
				data={data}
				totalItems={total}
				isLoading={isLoading}
			/>
		</div>
	)
}
